import { Availability, PreferenceInformation, EmergencyContact, PersonalDetails, User, UserBasicInfo, MemberSubscription } from "../../types/user";

export function normalizeUserData(apiUser: User, memberSubscription?: MemberSubscription, hash?:string) {
  const memberData = apiUser._data || {};
    
  let partnerId = 'NONE';
    
  // Check if primaryPartnerName is explicitly set to 'NONE'
  if (memberData.primaryPartnerName === 'NONE') {
    // Use 'NONE' when explicitly set that way
    partnerId = 'NONE';
  } 
  else if(memberData?.primaryPartnerName !== 'NONE' && memberData._partners && memberData._partners.length > 0) {
    partnerId = memberData._partners[memberData._partners.length - 1];
  }
  function normalizeValue(val: string) {
    return val === "undefined" ? undefined : val;
  }
  
  const basicInfo: UserBasicInfo = {
    _id: apiUser._id,
    phone: apiUser.phone,
    partnerId: partnerId,
    primaryPartnerName: memberData.primaryPartnerName || '',
    stripeCustomerId: memberData.stripeCustomerId || '',
    memberSource: memberData.memberSource || '',
    currentStatus: memberData.currentStatus || '',
    type: apiUser.type,
    isInOnboarding: memberData.isInOnboarding,
    userEnrollment: memberData.userEnrollment || undefined,
    termsOfServiceAccepted: memberData.termsOfServiceAccepted,
    privacyPolicyAccepted: memberData.privacyPolicyAccepted ,
    isFirstTimeLogin: apiUser.isFirstTimeLogin,
    emailVerified: apiUser.emailVerified,
    phoneVerified:apiUser.phoneVerified,
    deleted: apiUser.deleted
  };
    
  const personalDetails: PersonalDetails = {
    firstName: apiUser.firstName || '',
    lastName: apiUser.lastName || '',
    preferredName: memberData.preferredName || '',
    email: apiUser.email || '',
    dob: apiUser.dob || '',
    races: memberData.races || [],
    sexualOrientation: normalizeValue(memberData.sexualOrientation) || '',
    pronounsList: memberData.pronounsList || [],
    gender: apiUser.gender || '',
    school: memberData.school || '',
    address: apiUser.address || '',
    city: apiUser.city || '',
    state: apiUser.state || '',
    zip: apiUser.zip || '',
    hash: hash || ''
    // preferredLanguage: memberData.settings?.language || ''
  };
    
  const preferenceInformation: PreferenceInformation = {
    hopeToGain: memberData.hopeToGain || '',
    preferredCoachGenders: memberData.preferredCoachGenders || '',
    preferredCoachEthnicities: memberData.preferredCoachEthnicities || [],
    preferredCoachSexualOrientations: memberData.preferredCoachSexualOrientations || '',
  };
    
  const availability: Availability = {
    shiftTime: memberData.shiftTime || '',
    shiftDays: memberData.shiftDays || []
  };
    
  const emergencyContact: EmergencyContact = {
    contactName: memberData.contactName || '',
    contactPhone: memberData.contactPhone || '',
    contactRelationship: memberData.contactRelationship || ''
  };

  const subscription: MemberSubscription = {
    messagesLimit: memberSubscription?.messagesLimit || 0,
    messagesRemaining: memberSubscription?.messagesRemaining || 0,
    status: memberSubscription?.status || '',
    _id: memberSubscription?._id || '',
    subscriptionId: memberSubscription?.subscriptionId || '',
    customerId: memberSubscription?.customerId || '',
    memberId: memberSubscription?.memberId || '',
    productId: memberSubscription?.priceId || '',
    firstPaymentId: memberSubscription?.firstPaymentId || '',
    startDate: memberSubscription?.startDate || '',
    endDate: memberSubscription?.endDate || '',
    createdAt: memberSubscription?.createdAt || '',
    updatedAt: memberSubscription?.updatedAt || '',
    amount: (memberSubscription?.amount || 0) / 100,
    priceId: memberSubscription?.priceId || ''
  }
     
  return {
    basicInfo,
    personalDetails,
    preferenceInformation,
    availability,
    emergencyContact,
    subscription
  };
}